/**
 * HTTP layer for customer products. The products associated with a customer.
 *
 * Contains:
 * - fetchCustomerProducts / fetchCustomerProduct: reads
 * - postCustomerProduct / patchCustomerProduct / deleteCustomerProduct: writes
 */
import apiClient from '@sophocles/http-common';

const CUSTOMER_PRODUCT_ENDPOINT = '/warehouse/customer-products';

export const fetchCustomerProducts = queryParams =>
  apiClient.get(`${CUSTOMER_PRODUCT_ENDPOINT}/`, { params: queryParams }).then(res => res.data);

export const fetchCustomerProduct = customerProductId =>
  apiClient.get(`${CUSTOMER_PRODUCT_ENDPOINT}/${customerProductId}/`).then(res => res.data);

export const postCustomerProduct = data => apiClient.post(`${CUSTOMER_PRODUCT_ENDPOINT}/`, data).then(res => res.data);

export const patchCustomerProduct = (customerProductId, data) =>
  apiClient.patch(`${CUSTOMER_PRODUCT_ENDPOINT}/${customerProductId}/`, data).then(res => res.data);

export const deleteCustomerProduct = customerProductId =>
  apiClient.delete(`${CUSTOMER_PRODUCT_ENDPOINT}/${customerProductId}/`);
